import { useTheme } from 'styled-components';

import { usePermissions } from '~/shared/hooks/usePermissions';
import { useMediaQuery } from '~/shared/hooks/useMediaQuery';

import { WithChildren } from '~/shared/types/WithChildren';

import { Container, Content, ContentWrapper } from './styles';

import { Toolbar } from './Toolbar';
import { SideBar } from './SideBar';

export const DefaultLayout: WithChildren = ({ children }) => {
  const { permissions } = usePermissions();

  const theme = useTheme();

  const isSmallerThan850 = useMediaQuery(
    `(max-width: ${theme.breakpoints.tablet})`
  );

  return (
    <Container>
      <Toolbar />

      <ContentWrapper>
        {!isSmallerThan850 && <SideBar permissions={permissions} />}

        <main id="main-element">
          <Content>{children}</Content>
        </main>
      </ContentWrapper>
    </Container>
  );
};
